export default {
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/index.js